import React from 'react';
type SectionHeadingProps = {
  index?: string;
  label: string;
  title: string;
  description?: string;
};
export function SectionHeading({
  index,
  label,
  title,
  description
}: SectionHeadingProps) {
  return <div className="max-w-2xl" data-id="element-669" data-mp="3f25c14r7ckko">
      <p className="text-xs font-medium text-rust" data-id="element-670" data-mp="3f2x0zwqank1z">
        {index && <span className="tabular-nums" data-id="element-671" data-mp="3k188i0t49ih1">{index} / </span>}
        {label}
      </p>
      <h2 className="mt-2 text-2xl font-semibold tracking-tight text-ink md:text-[28px]" data-id="element-672" data-mp="bjtxtxgduq2n">{title}</h2>
      {description && <p className="mt-2 text-sm leading-relaxed text-fg-muted" data-id="element-673" data-mp="giew3rc2qzog">{description}</p>}
    </div>;
}